import React from 'react';
import { useAppSelector } from '@/app/hooks';
import { Counter, InfoIcon, SectionCard } from './ProgramCard.styles';
import { Value } from './ProgramInfo.styles';

interface IProgramInfoProps {
  value: number | string | JSX.Element;
  label: string;
  subLabel: string;
  isInfoIcon: boolean;
  onInfoClick: (info: any) => void;
  counter?: string;
  $lender?: string;
  isHidden?: boolean;
}

const ProgramInfoComponent = ({
  value = 0,
  label = '',
  subLabel = '',
  counter = '',
  onInfoClick,
  isInfoIcon = false,
  $lender = import.meta.env.VITE_MOCKED_ORIGIN || '',
  isHidden = false,
}: IProgramInfoProps) => {
  const templateConfig = useAppSelector((state) => state.TemplateConfig);
  const isOriginationFee = subLabel === 'Origination Fee';

  const programCardBackgroundColor = templateConfig?.globalTheme?.wcagNumericDetailBackColor || '#5E6572';
  const programCardTextColor = templateConfig?.globalTheme?.wcagNumericDetailTextColor || '#FFFFFF';
  const programCardColorFill = templateConfig?.globalTheme?.wcagDetailContainerColorFill || '#FFFFFF';
  const programCardShadow = templateConfig?.globalTheme?.wcagDetailContainerShadow || '0px 0px 2px rgba(0, 0, 0, 0.25)';

  return (
    // TO-DO Improve the lender usage
    <SectionCard
      $isOriginationFee={isOriginationFee}
      $lender={$lender.includes('empowerfcu') ? 'empowerfcu' : 'loandepot'}
      $backgroundColor={programCardColorFill}
      $shadow={programCardShadow}
      $isHidden={isHidden}
    >
      {' '}
      <div style={{ backgroundColor: programCardBackgroundColor, color: programCardTextColor }}>
        <Value>{value}</Value>
      </div>
      <p>{label}</p>
      <p>
        {subLabel} <Counter>{counter}</Counter>
      </p>
      {isInfoIcon && <InfoIcon data-testid="info-icon" onClick={onInfoClick} aria-label={`More information about ${label}`} color={$lender} />}
    </SectionCard>
  );
};

export const ProgramInfo = React.memo(ProgramInfoComponent);
